import { render, staticRenderFns } from "./v-email-field.vue?vue&type=template&id=23d78fea&scoped=true"
import script from "./v-email-field.vue?vue&type=script&lang=js"
export * from "./v-email-field.vue?vue&type=script&lang=js"
import style0 from "./v-email-field.vue?vue&type=style&index=0&id=23d78fea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23d78fea",
  null
  
)

export default component.exports